import React from 'react'
import { Typography } from '@material-ui/core'

const OptionsMenu = ({ dataUser }) => {

    return(
    <Typography variant="body2" >
        {/* <Link href="#" className={classes.menuLink}>
            <MenuItem  onClick={() => console.log('clicked!')}>
            <Button startIcon={<HomeIcon className={classes.menuIcon} />}>
                Biblioteca
            </Button>
            </MenuItem>
        </Link>
        <Link href="#" className={classes.menuLink}>
            <MenuItem  onClick={() => console.log('clicked!')}>
            <Button startIcon={<ContactSupportIcon className={classes.menuIcon} />}>
                Banco de questões
            </Button>
            </MenuItem>
        </Link>
        <Link href="#" className={classes.menuLink}>
            <MenuItem  onClick={() => console.log('clicked!')}>
            <Button startIcon={<FileCopyIcon className={classes.menuIcon} />}>
                Simulados
            </Button>
            </MenuItem>
        </Link>
        <Link href="#" className={classes.menuLink}>
            <MenuItem  onClick={() => console.log('clicked!')}>
            <Button startIcon={<QuestionAnswerIcon className={classes.menuIcon} />}>
                Forum
            </Button>
            </MenuItem>
        </Link>
        <Link href="#" className={classes.menuLink}>
            <MenuItem  onClick={() => console.log('clicked!')}>
                <Button startIcon={<DvrIcon className={classes.menuIcon} />}>
                    Blog
                </Button>
            </MenuItem>
        </Link> */}
    </Typography>
    )
}

export default OptionsMenu